<template>
    <Handle type="target" :position="Position.Left" id="input" />
    <NodeBase title="Screenshot" icon="📷" color="#dc2626">
        <p class="text-gray-400 italic">Saves display as BMP</p>
    </NodeBase>
    <Handle type="source" :position="Position.Right" id="output" />
</template>

<script setup>
defineOptions({ inheritAttrs: false });
import { Handle, Position } from '@vue-flow/core';
import NodeBase from './NodeBase.vue';

defineProps({ id: String, data: Object });
</script>
